var app = angular.module('tf.leagues.create', [])
    .controller('createLeagueCtrl', ['$scope', '$http', 'leaderBoardService', '$state', '$uibModalInstance', createLeagueCtrl]);

/** ngInject */
function createLeagueCtrl($scope, $http, leaderBoardService, $state, $uibModalInstance) {

    $scope.saving = false;
    $scope.emails = [];
    $scope.leagueCode = null;
    $scope.leagueName = null;

    $scope.newLeague = {
        private: false,
        description: "",
        level: null,
        inviteEmails: []
    };

    $scope.updateEmails = function() {
        $scope.newLeague.inviteEmails = $scope.emails.map(function(e) {
            return e.text;
        });
    };

    function createSuccess(result) {
        var data = result.data;
        $scope.saving = false;
        $uibModalInstance.close();
        $state.go("leagues", {board: +data});
    }

    function createError() {
        $scope.saving = false;
        // TODO SOMETHING WENT WRONG AND IT WAS PROBABLY USER ERROR
    }

    $scope.createLeague = function () {
        $scope.saving = true;
        var url = '/tradefloor/api/leaderboards';
        $http.post(url, $scope.newLeague)
            .then(createSuccess, createError);
    };

}
